import { jsx as a } from "react/jsx-runtime";
import { c as m } from "react/compiler-runtime";
import { Radio as p } from "@mui/material";
import { forwardRef as d } from "react";
const u = d((i, f) => {
  const t = m(11);
  let o, e;
  t[0] !== i ? ({
    sx: e,
    ...o
  } = i, t[0] = i, t[1] = o, t[2] = e) : (o = t[1], e = t[2]);
  let s;
  t[3] !== e ? (s = Array.isArray(e) ? e : [e], t[3] = e, t[4] = s) : s = t[4];
  let r;
  t[5] !== s ? (r = [y.defaultStyles, ...s], t[5] = s, t[6] = r) : r = t[6];
  let l;
  return t[7] !== o || t[8] !== f || t[9] !== r ? (l = /* @__PURE__ */ a(p, { ref: f, sx: r, ...o }), t[7] = o, t[8] = f, t[9] = r, t[10] = l) : l = t[10], l;
}), y = {
  defaultStyles: {
    p: 0
  }
};
export {
  u as Radio
};
